import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import BlueButton from "../../../components/BlueButton/BlueButton.js";
import { toast } from "react-toastify";
import Api from "../../../Api.js";
import {word} from '../../../word.js';
import Cookies from 'js-cookie';
import SuccessToast from "../../BlueButton/SuccessToast.js";

const Password = ({ close }) => {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");
    const [submit, setSubmit] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const login = useSelector((state) => state.manager.employee);
    const keyPress = async (e) => {
        if (e.key === "Enter") {
            await submitForm();
        }
    };

    const submitForm = async () => {
        try{
            setSubmit(true);
            if (!oldPassword || !newPassword || !repeatPassword || newPassword !== repeatPassword) {
                return;
            }
            setDisabled(true);
            const form = {
                email: login.user.email,
                old_password: oldPassword,
                new_password: newPassword,
                repeat_password: repeatPassword
            };
            let id = Cookies.get("id");
            const {data} = await Api.changePassword(form, id)
            localStorage.setItem("token", data.token);
            close();
            SuccessToast();

        }catch (e) {
            toast.error(e.response.data.message,  { position: "top-center",theme: "colored", });
        }
    };

    return (
        <div className="settings-item-password">
            <i className="fa fa-times" aria-hidden="true" onClick={close}/>
            <Form>
                <Form.Group className="justify-content-center form-group" controlid="exampleForm.ControlInput1">
                    <Form.Control
                        placeholder="Հին գաղտնաբառ"
                        type="password"
                        className={!oldPassword && submit ? "form-control is-invalid" : "form-control"}
                        autoComplete="off"
                        onKeyDown={keyPress}
                        onChange={(e) => setOldPassword(e.target.value)}
                    />
                    {!oldPassword && submit && (
                        <div className="validation valid-center">
                            <span>{word.password_error}</span>
                        </div>
                    )}
                </Form.Group>

                <Form.Group className="justify-content-center form-group" controlid="exampleForm.ControlInput1">
                    <Form.Control
                        placeholder="Նոր գաղտնաբառ"
                        type="password"
                        className={newPassword.length < 6 && submit ? "form-control is-invalid" : "form-control"}
                        autoComplete="off"
                        onKeyDown={keyPress}
                        onChange={(e) => setNewPassword(e.target.value)}
                    />
                    {newPassword.length < 6 && submit && (
                        <div className="validation valid-center">
                            <span>{word.password_error}</span>
                        </div>
                    )}
                </Form.Group>

                <Form.Group className="justify-content-center form-group" controlid="exampleForm.ControlInput1">
                    <Form.Control
                        placeholder="Կրկնել գաղտնաբառը"
                        type="password"
                        className={(repeatPassword !== newPassword || repeatPassword.length < 6) && submit ? "form-control is-invalid" : "form-control"}
                        autoComplete="off"
                        onKeyDown={keyPress}
                        onChange={(e) => setRepeatPassword(e.target.value)}
                    />
                    {(repeatPassword !== newPassword || repeatPassword.length < 6) && submit && (
                        <div className="validation valid-center">
                            <span>Պետք է լինի նախորդ դաշտի նման</span>
                        </div>
                    )}
                </Form.Group>
            </Form>

            <BlueButton disabled={disabled} onChangeValue={submitForm} title="Հաստատել" />
        </div>
    );
};

export default Password;
